import { render, staticRenderFns } from "./LoadingSideNav.vue?vue&type=template&id=ff0615b8"
import script from "./LoadingSideNav.vue?vue&type=script&lang=ts"
export * from "./LoadingSideNav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports